import React from "react";
import HeroImage from "./img/image.png";
import SmallImage from "./img/tech.png";

const Home = React.forwardRef((props, ref) => (
  <section
    ref={ref}
    style={{
      minHeight: "100vh",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "2rem",
      textAlign: "left",
      background: "linear-gradient(to right, #f8f4e3, #ffe4c4)",
      backgroundAttachment: "fixed",
      position: "relative",
      overflow: "hidden",
      flexWrap: "wrap",
      gap: "2rem",
    }}
  >
    {/* Left Content */}
    <div style={{ flex: "1 1 450px", zIndex: 1 }}>
      <h1
        style={{
          fontSize: "clamp(2.5rem, 5vw, 4.5rem)",
          color: "#8B4513",
          textShadow: "2px 2px 5px rgba(0,0,0,0.2)",
          animation: "fadeIn 1s ease-in-out",
        }}
      >
        Innovate. Create. Inspire.
      </h1>

      <p
        style={{
          fontSize: "clamp(1rem, 2vw, 1.25rem)",
          maxWidth: "600px",
          marginTop: "1rem",
          animation: "fadeIn 1.5s ease-in-out",
        }}
      >
        Building modern, responsive websites and web apps that empower businesses
        to succeed online. Let's craft digital experiences that make a difference.
      </p>

      {/* CTA Cards */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "1rem",
          marginTop: "2rem",
        }}
      >
        {/* Explore Services */}
        <div
          onClick={props.scrollToServices}
          style={{
            cursor: "pointer",
            padding: "1rem 2rem",
            background: "#A0522D",
            color: "#fff",
            fontWeight: "bold",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            transition: "all 0.3s ease",
            boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#8B4513")}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#A0522D")}
        >
          Explore
          <span style={{ display: "inline-block", transition: "transform 0.3s ease" }}>
           👇
          </span>
        </div>

        {/* Contact Us */}
        <div
          onClick={props.scrollToContact}
          style={{
            cursor: "pointer",
            padding: "1rem 2rem",
            background: "#000",
            color: "#fff",
            fontWeight: "bold",
            border: "2px solid #f7f7f7",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            transition: "all 0.3s ease",
            boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#A0522D";
            e.currentTarget.style.color = "#1c1212";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#000";
            e.currentTarget.style.color = "#fff";
          }}
        >
          Great
          <span style={{ display: "inline-block", transition: "transform 0.3s ease" }}>
             💪
          </span>
        </div>
      </div>

      {/* Stats */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "flex-start",
          gap: "2rem",
          marginTop: "2rem",
          fontWeight: "bold",
          color: "#8B4513",
          fontSize: "clamp(0.9rem, 1.5vw, 1.25rem)",
          animation: "fadeInUp 1.5s ease forwards",
        }}
      >
        <div style={{ textAlign: "center" }}>
          <div style={{ marginBottom: "0.25rem" }}>Reviews</div>
          <div style={{ fontSize: "clamp(1.2rem, 2vw, 1.5rem)", color: "#A0522D" }}>
            120+
          </div>
        </div>

        <div style={{ borderLeft: "1px solid #8B4513", height: "40px", alignSelf: "center" }}></div>

        <div style={{ textAlign: "center" }}>
          <div style={{ marginBottom: "0.25rem" }}>Projects</div>
          <div style={{ fontSize: "clamp(1.2rem, 2vw, 1.5rem)", color: "#A0522D" }}>
            50+
          </div>
        </div>

        <div style={{ borderLeft: "1px solid #8B4513", height: "40px", alignSelf: "center" }}></div>

        <div style={{ textAlign: "center" }}>
          <div style={{ marginBottom: "0.25rem" }}>Rating</div>
          <div style={{ fontSize: "clamp(1.2rem, 2vw, 1.5rem)", color: "#A0522D" }}>
            4.9/5
          </div>
        </div>
      </div>
    </div>

    {/* Right Image */}
    <div
      style={{
        flex: "1 1 350px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      <img
        src={HeroImage}
        alt="Hero"
        style={{
          maxWidth: "100%",
          height: "auto",
          animation: "float 3s ease-in-out infinite",
        }}
      />
      <img
        src={SmallImage}
        alt="Small"
        style={{
          position: "absolute",
          right: "20px",
          bottom: "72%",
          width: "100px",
          height: "100px",
          objectFit: "contain",
          animation: "float 3s ease-in-out infinite",
        }}
      />
    </div>

    {/* Keyframes */}
    <style>
      {`
        @keyframes fadeIn {
          0% { opacity: 0; transform: translateY(20px);}
          100% { opacity: 1; transform: translateY(0);}
        }
        @keyframes fadeInUp {
          0% { opacity: 0; transform: translateY(20px);}
          100% { opacity: 1; transform: translateY(0);}
        }
        @keyframes float {
          0% { transform: translateY(0); }
          50% { transform: translateY(-20px); }
          100% { transform: translateY(0); }
        }
        div:hover .arrow {
          transform: translateX(5px);
        }
      `}
    </style>
  </section>
));

export default Home;
